const COOKIE_KEYS = {
  VERIFIED_MANUFACTURERS_ONLY_UPB: 'verifiedManufacturersOnlyUPB', // UPB
  BRAND_HARVEST_FILTERS: 'brandHarvestFilters', // Brand Enrich
  AUTH_USER: 'AUTH_USER', // Authentication
  SUPPORT_TICKET_FILTERS: 'SupportTicketFilters', //Support Tickets
};

export default COOKIE_KEYS;
